const getDefaultState = () => ({
  seasons: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  suppliers: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  salesTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  packages: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  levels: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  skiTypes: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  season: {
    itemsError: undefined,
    itemsLoading: false,
    saveError: undefined,
    saveLoading: false,
    id: undefined,
    twentySupplierId: undefined,
    name: undefined,
    active: true,
    webActive: true,
    commissionRatio: 0,
    contributionRatio: 0,
    bookDaysBeforeArrival: 0,
    priceAdjustmentValue: 1,
    netOrGross: 'gross',
    salesRule: 'booking',
    informationText: null,
    supplier: undefined,
    newSeasonItem: {
      itemsError: undefined,
      itemsLoading: false,
      saveError: undefined,
      saveLoading: false,
      id: undefined,
      twentySupplierId: undefined,
      name: undefined,
      active: true,
      webActive: true,
      commissionRatio: 0,
      contributionRatio: 0,
      bookDaysBeforeArrival: 0,
      priceAdjustmentValue: 1,
      netOrGross: 'gross',
      salesRule: 'booking',
      informationText: null,
      supplier: undefined,
    },
    periodDates: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newPeriodItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
      },
    },
    personCategories: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: null,
        skiRentalSeasonId: null,
        name: null,
        externalName: null,
        ageFrom: null,
        ageTo: null,
        xmlChannelProductId: null,
      },
    },
    prices: {
      items: [],
      itemsLoading: false,
      itemsError: null,
      saveLoading: false,
      saveError: null,
      newPriceItem: {
        id: null,
        skiRentalSeasonId: null,
        skiRentalSeasonPersonCategoryId: null,
        skiRentalSkiTypeId: null,
        skiRentalPackageId: null,
        skiRentalLevelId: null,
        xmlChannelProductId: null,
        name: null,
        externalName: null,
        days: {},
      },
    },
    priceCombinations: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      defaultNumberOfDays: [2, 3, 4, 5, 6, 7, 8, 10, 12, 14],
      selectedPersonCategoryIds: [],
      selectedLevelIds: [],
      selectedSkiTypeIds: [],
      selectedPackageIds: [],
      onlyShowSavedPrices: false,
      onlyShowPricesMissingXmlChannelProducts: false,
    },
    discounts: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      saveLoading: false,
      saveError: undefined,
      newItem: {
        id: undefined,
        skiRentalSeasonId: undefined,
        bookFrom: undefined,
        bookTo: undefined,
        arrivalFrom: undefined,
        arrivalTo: undefined,
        minPax: undefined,
        maxPax: undefined,
        percentage: undefined,
      },
      personCategories: {
        itemsLoading: false,
        itemsError: undefined,
        saveLoading: false,
        saveError: undefined,
      },
    },
    skiAreas: {
      items: [],
      itemsLoading: false,
      itemsError: undefined,
      ids: [],
    },
  },
  pickupPlaces: {
    loading: false,
    error: false,
    items: [],
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/ski/rental/defaultState.js